<template>
    <Field
            :labelFor="name"
            :title="title"
            :value="value"
            :errorMessage="errorMessage"
            :description="description"
            :helpText="helpText"
            :required="required"
    >
        <template v-slot:input>
            <textarea
                    v-model="model"
                    :name="name"
                    :id="name"
                    :disabled="disabled"
                    :maxlength="maxLength"
                    md-autogrow
                    class="form__control form__control--textarea"
            >
                {{value}}
            </textarea>
        </template>
    </Field>
</template>

<script>
    import FieldMixin from '../../mixins/FieldMixin'

    export default {
        name: 'FieldTextarea',
        mixins: [
            FieldMixin
        ],
    }
</script>


// WEBPACK FOOTER //
// src/modules/form/components/fields/FieldTextarea.vue